/**
 * useSearchQueryParam
 */

import {
    useCallback,
    useMemo,
} from 'react';
import {
    useLocation,
    useHistory,
} from 'react-router-dom';
import 'url-search-params-polyfill';

import useMediaConfig from 'bdvp-common/src/hooks/config/useMediaConfig';
import {
    MEDIA_CONFIG_CONTEXT,
    QUERY_PARAMS,
    SEARCH_ROUTE
} from 'bdvp-common/src/utils/constants';
import {
    Queries,
    ApolloLib,
} from 'bdvp-graphql';

import { buildQuery } from '../../utils/queryUtils';
import { FALLBACK_SORT } from '../../utils/constants';

const { useApolloClient } = ApolloLib;

const { GET_SEARCH_SORT } = Queries;

const useSearchQueryParam = () => {

    const history = useHistory();
    const location = useLocation();
    const urlParams = useMemo(() => {

        return new URLSearchParams(location.search);

    }, [location.search]);
    const client = useApolloClient();
    const config = useMediaConfig(MEDIA_CONFIG_CONTEXT.search);

    const searchQuery = urlParams.get(QUERY_PARAMS.query);
    const queryType = urlParams.get(QUERY_PARAMS.queryType);

    const updateSearchQuery = useCallback((filters) => {

        const { searchSort } = client.readQuery({ query: GET_SEARCH_SORT });
        const query = buildQuery(filters, searchSort ?? (config?.sortOptions?.[0]?.value ?? FALLBACK_SORT));

        urlParams.set(QUERY_PARAMS.query, query);
        urlParams.delete(QUERY_PARAMS.queryType);

        history.push({
            pathname: SEARCH_ROUTE,
            search: urlParams.toString(),
        });

    }, [
        history,
        urlParams,
        client,
        config,
    ]);

    return {
        searchQuery,
        updateSearchQuery,
        queryType,
    };

};

export default useSearchQueryParam;
